export default __webpack_public_path__ + "static/media/example_2.83ab3dad.png";